import { Paginator } from '@/models/globalModels';
import { SaveShareLinkType, ShareLink } from '@/models/shareModels';
import LocalDataService from '@/services/LocalDataService';

import { api } from '../api';

const urls = {
  create: (userId: number) => `/tables/ambassadors/${userId}/actions/custom_url/create/`,
  save: (uid: number) => `/urls/${uid}/`,
  shares: (userId: number) => `/ambassadors/${userId}/custom_urls/`,
};

// We need to hardcode to get all the share link available (This is used mostly for editing the share link of a campaign)
// The improvement should be on the BE, returning more values for the campaign link or providing an endpoint by id
const PAGE_SIZE = 200;

export const getShare = async (shareLinkId: number) => {
  const userId = LocalDataService.getUid();
  const params = {
    ordering: '-created_at',
    page: 1,
    page_size: PAGE_SIZE,
  };
  const data = await api.get<Paginator<ShareLink>>(urls.shares(userId), { params });
  return data.results.find((share) => share.uid === shareLinkId);
};

export const createShareLink = async (shareLink: Omit<SaveShareLinkType, 'uid'>) => {
  const ambassador = LocalDataService.getUid();
  const data = await api.post<ShareLink>(urls.create(ambassador), shareLink);
  return data;
};

export const saveShareLink = async (shareLink: SaveShareLinkType) => {
  const data = await api.patch<ShareLink>(urls.save(shareLink.uid), shareLink);
  return data;
};
